/**
 *
 * ConfirmProfile
 *
 */

import React, { memo, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// layout components
import Preloader from "components/Preloader";


// antd component
import { Button, message } from "antd";

// assets
import CustomIcons from "components/CustomIcons";

// utils
import api from "utils/api";
import { parseQuery } from "utils/history";

function ConfirmProfile({ history, className }) {
  const { t } = useTranslation();
  const location = useLocation();

  const [isLoadingConfirm, setIsLoadingConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);

 // const urlParams = new URLSearchParams(location.search);
  const urlParams = parseQuery(location.search);

  console.log({ urlParams });

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    // --> main code here

    if (urlParams?.id) {
      confirmProfileCallback(urlParams?.id, urlParams?.email);
    }
    // Anything in here is fired on component unmount.
    return () => {
      // Clearing the state after unmounting a component
    };
  }, []);

  const confirmProfileCallback = (id, email = null) => {
    setIsLoadingConfirm(true);
    api.auth.confirmProfile({
      token: id,
      email: email.toString(),
    })
    .then(result => {
      setIsLoadingConfirm(false);
      setIsConfirmed(true);
    })
    .catch(err => {
      setIsLoadingConfirm(false);
      setIsConfirmed(false);
      message.error(err.message, 5);
    });
  };
  const resendConfirmProfileCallback = () => {
    setIsLoading(true);
    api.auth.resendConfirmProfile({
      email: urlParams?.email || null,
    })
    .then(result => {
      setIsLoading(false);
      setIsConfirmed(true);
      message.success(result.message, 5);
    })
    .catch(err => {
      setIsLoading(false);
      setIsConfirmed(false);
      console.error({ err }, err?.response?.data?.errors?.message);
      message.error(t("errors.somethingWrongTryAgain"), 5);
    });
  };

  // render function
  return (
    <>
      {isLoadingConfirm && <Preloader fullWidth />}
      {!isLoadingConfirm && (
        <>
          <div className="login-page">
            <div className="login-form__column">
              <div className="login-form__header">
                <CustomIcons className="logo-login" type="logo" />
              </div>

              <div className="login-form__container">
                {!!isConfirmed && (
                  <>
                    <h3 style={{ color: "#fff" }}>{t("pages.emailConfirmedProfile")}</h3>

                    <p className="description">
                      {t("pages.emailConfirmedProfileMsg")}
                    </p>
                  </>
                )}
                {!isConfirmed && (
                  <>
                    <p className="disclaimer">
                      {t("pages.sendConfirmationProfileError")}
                    </p>
                    <Button
                      type="primary"
                      htmlType="submit"
                      block
                      size="large"
                      className="login-submit"
                      loading={isLoading}
                      onClick={resendConfirmProfileCallback}
                    >
                      {t("pages.sendConfirmationProfile")}
                    </Button>
                  </>
                )}
              </div>
            </div>

            <svg
              className="waves"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 24 150 28"
              preserveAspectRatio="none"
              shapeRendering="auto"
            >
              <defs>
                <path
                  id="gentle-wave"
                  d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                />
              </defs>
              <g className="parallax">
                <use
                  href="#gentle-wave"
                  x="48"
                  y="0"
                  fill="rgba(255,255,255,0.7"
                />
                <use
                  href="#gentle-wave"
                  x="48"
                  y="3"
                  fill="rgba(255,255,255,0.5)"
                />
                <use
                  href="#gentle-wave"
                  x="48"
                  y="5"
                  fill="rgba(255,255,255,0.3)"
                />
                <use href="#gentle-wave" x="48" y="7" fill="#fff" />
              </g>
            </svg>
          </div>
        </>
      )}
    </>
  );
}

export default memo(ConfirmProfile);
